import { ReactElement } from 'react';
import { AdminService, MembershipService, useApiEffect, useApiGetter } from '@localstack/services';

import { OrganizationDetails, OrganizationDetailsSkeleton } from '../components';

export interface BasicDetailsProps {
  orgId: string;
}

export const BasicDetails = ({ orgId }: BasicDetailsProps): ReactElement => {
  const { data: organization } = useApiGetter(AdminService, 'getOrganization', [orgId]);
  const { data: subscriptions } = useApiGetter(AdminService, 'listOrganizationSubscriptions', [orgId]);

  // todo: switch to getOrganizationStats instead (its faster) once it is exposed to the admin side
  const { data: members } = useApiGetter(MembershipService, 'adminListMembers', [orgId], { defaultValue: [] });

  const { updateOrganization, isLoading: isOrgMutating } = useApiEffect(AdminService, ['updateOrganization'], {
    revalidate: ['getOrganization'],
  });

  if (!organization) {
    return <OrganizationDetailsSkeleton />;
  }

  return (
    <OrganizationDetails
      loading={isOrgMutating}
      organization={organization}
      members={members}
      subscriptions={subscriptions ?? []}
      onUpdate={updateOrganization}
    />
  );
};
